import onLoadShared from "../shared/on_load"

onLoadShared.run()

import onLoad from "../sites/music/on_load"

onLoad.run()

